export default "__VITE_ASSET__BSnKNlqe__"